<template>
    <div class="tax-mask" @click.stop="set_tax_mask_hide" @touchmove.prevent="event_touchmove">
        <p class="tax-wrapper">
            海外商品税金预计：¥{{taxStr}}
        </p>
    </div>
</template>

<script>
    import {mapMutations} from 'vuex';

    const SEC = require('common/js/utils/core.js');

    export default {
        name: '',
        props: {
            tax: {
                type: Number,
                default: 0
            }
        },
        computed: {
            // 加工后的税金
            taxStr () {
                return SEC.number.currency(this.tax, 2);
            }
        },
        methods: {
            ...mapMutations({set_tax_mask_hide: 'SET_TAX_MASK_HIDE'}),
            // 阻止弹窗出现后还可滚动的问题
            event_touchmove () {
                return false;
            }
        }
    }
</script>

<style lang="scss" scoped>
.tax-mask {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background-color: rgba(28, 23, 23, 0.4);
    .tax-wrapper {
        position: absolute;
        bottom: toRem(130);
        left: toRem(25);
        /*height: toRem(90);*/
        padding: toRem(25) toRem(16);
        background-color: #fff;
        font-family: FuturaLT-Light;
        font-size: toRem(28);
        color: $color-black;
        &:after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: toRem(-10);
            transform: translateX(-50%);
            border-top: toRem(12) solid #FFF;
            border-left: toRem(10) solid transparent;
            border-right: toRem(10) solid transparent;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/TaxMask/index.vue